import { render, staticRenderFns } from "./CopyPromotionList.vue?vue&type=template&id=adc1cf9e&scoped=true"
import script from "./CopyPromotionList.vue?vue&type=script&lang=js"
export * from "./CopyPromotionList.vue?vue&type=script&lang=js"
import style0 from "./CopyPromotionList.vue?vue&type=style&index=0&id=adc1cf9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc1cf9e",
  null
  
)

export default component.exports